import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../../shared/base-api-template-service.model';
import {Core2Config} from '../../../shared/core2Config';

@Injectable({
    providedIn: 'root'
  })
  export class JobShipmentBulkEditRemarksService extends BaseApiTemplateService<any> {

    readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-shipments/bulk-edit-remarks/backoffice-ep';
  
    constructor(http: HttpClient) {
      super();
      this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-shipments/bulk-edit-remarks/backoffice-ep';
      this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-shipments/bulk-edit-remarks/backoffice-ep';
      this.httpClient = http;
    }
  }